import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const safeFileName = (value) => (value || 'document').replace(/[^a-z0-9_-]+/gi, '-');
const resolveValue = (column, row, index) => {
  const value = typeof column.value === 'function' ? column.value(row, index) : row?.[column.value];
  return value ?? '';
};
const escapeXml = (value) => String(value ?? '').replace(/[<>&"']/g, char => ({
  '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&apos;'
}[char]));

export const downloadDetailPDF = ({ title, number, metadata = [], columns = [], rows = [], totals = [] }) => {
  const pdf = new jsPDF({ orientation: columns.length > 7 ? 'landscape' : 'portrait' });
  pdf.setFontSize(18);
  pdf.text(title.toUpperCase(), 14, 16);
  pdf.setFontSize(10);
  metadata.forEach((entry, index) => {
    const x = index % 2 === 0 ? 14 : 145;
    const y = 24 + Math.floor(index / 2) * 6;
    pdf.text(`${entry.label}: ${entry.value ?? '-'}`, x, y);
  });
  const startY = 28 + Math.ceil(metadata.length / 2) * 6;
  autoTable(pdf, {
    startY,
    head: [columns.map(column => column.label)],
    body: rows.map((row, index) => columns.map(column => resolveValue(column, row, index))),
    styles: { fontSize: columns.length > 7 ? 7 : 8 },
    headStyles: { fillColor: [249, 115, 22] },
  });
  let finalY = (pdf.lastAutoTable?.finalY || startY) + 8;
  pdf.setFontSize(10);
  totals.forEach(total => {
    pdf.text(`${total.label}: ${total.value}`, columns.length > 7 ? 210 : 140, finalY);
    finalY += 6;
  });
  pdf.save(`${safeFileName(number || title)}.pdf`);
};

export const downloadDetailExcel = ({ title, number, metadata = [], columns = [], rows = [], totals = [] }) => {
  const cell = (value, type = 'String') => `<Cell><Data ss:Type="${type}">${escapeXml(value)}</Data></Cell>`;
  const rowXml = (values) => `<Row>${values.map(value => cell(value)).join('')}</Row>`;
  const metadataRows = metadata.map(entry => rowXml([entry.label, entry.value ?? ''])).join('');
  const itemRows = rows.map((row, index) => `<Row>${columns.map(column => {
    const value = resolveValue(column, row, index);
    return cell(value, column.type === 'number' ? 'Number' : 'String');
  }).join('')}</Row>`).join('');
  const totalRows = totals.map(total => rowXml([total.label, total.rawValue ?? total.value])).join('');
  const workbook = `<?xml version="1.0"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"><Worksheet ss:Name="${escapeXml(title).slice(0, 31)}"><Table>${rowXml([title])}${metadataRows}${rowXml([])}${rowXml(columns.map(column => column.label))}${itemRows}${rowXml([])}${totalRows}</Table></Worksheet></Workbook>`;
  const url = URL.createObjectURL(new Blob([workbook], { type: 'application/vnd.ms-excel' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${safeFileName(number || title)}.xls`;
  link.click();
  URL.revokeObjectURL(url);
};

export const buildDocumentShareText = ({ title, number, shareLines = [] }) => [
  `${title} ${number || ''}`.trim(),
  ...shareLines,
  window.location.href,
].join('\n');
